import $ from 'jquery'
import moment from 'moment'
import ComitiumLiveEventSocket from "./comitium-live-socket";
import Swiper from "swiper/bundle";

class LiveEventsManager {
    constructor() {
        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }

        this.liveEventTitleData = 'live-event-title';
        this.liveEventPermalinkData = 'live-event-permalink';
        this.liveEventTypeData = 'live-event-type';
        this.intervalSecondsData = 'live-event-interval-seconds';
        this.jsonUrlData = 'live-event-json-url';
        this.pageUrlData = 'live-event-page-url';
        this.objectIdData = 'live-event-object-id';
        this.containerSelector = '#live-events-container';
        this.notificationSoundData = 'live-event-notification-sound';
        this.updatedAtSelector = '#live-event-update-at';
        this.orderData = 'order'; // NO trobat
        this.orderSelectedData = 'order-selected';
        this.scoreBoardSelector = '#live-event-scoreboard';
        this.scoreBoardUpdateData = 'url-update';
        this.liveEventTypologyData = 'live-event-typology';
        this.isCommentData = 'live-event-is-comment';
        this.comscoreUrlData = 'live-event-comscore-url';
        this.postTemplateData = 'post-template';
        this.postSportTemplateData = 'sport-post-template';
        this.scoreBoardTemplateData = 'scoreboard-template';
        this.webSocketAppKeyData = 'app-key';
        this.localeData = 'live-event-locale';
        this.firstPageElementsCountData = 'first-page-elements-count';
        this.subSiteAcronymData = "subsite-acronym";
        this.freeTextFirstData = "free-text-first";
        this.freeTextRestData = "free-text-rest";
        this.freeTextSecondData = "free-text-second";
        this.freeTextProrrogaData = "free-text-prorroga";
        this.freeTextPenaltiesData = "free-text-penalties";
        this.freeTextFinalData = "free-text-final";
        this.lastUpdateData = "last-update";
        this.scoreboardStartDateData = "scoreboard-start-date";
        this.currentFreeTextData = "scoreboard-free-text";
        this.bannerIntervalData = "banner-interval";

        this.TEMPLATE_TITLE_PLACEHOLDER = '__TITLE__';
        this.TEMPLATE_ID_PLACEHOLDER = '__ID__';
        this.TEMPLATE_HOUR_PLACEHOLDER = '__HOUR__';
        this.TEMPLATE_DESCRIPTION_PLACEHOLDER = '__DESCRIPTION__';
        this.TEMPLATE_TITLE_SHORT_PLACEHOLDER = '__TITLE_SHORT__';
        this.TEMPLATE_DATE_PLACEHOLDER = '__DATE__';
        this.TEMPLATE_SHORT_URL_PLACEHOLDER = '__URL_SHORT__';
        this.LOADING_CLASS = 'is-loading';
        this.TYPOLOGY_SPORTS = 'sports';
        this.TYPOLOGY_GENERAL = 'general';

        this.interval = null;
        this.intervalSeconds = null;
        this.type = null;
        this.jsonUrl = null;
        this.pageUrl = null;
        this.objectId = null;
        this.lastTimeStamp = null;
        this.commentContainer = $(this.containerSelector);
        this.notificationSound = null;
        this.order = 'desc';
        this.scoreBoardUpdateUrl = null;
        this.typology = null;
        this.currentUrl = window.location.origin + window.location.pathname;
        this.comscorePageViewCandidateUrl = null;
        this.postTemplate = '';
        this.postSportTemplate = '';
        this.scoreBoardTemplate = '';
        this.scoreBoardTimeTemplate = '';
        this.webSocketAppKey = null;
        this.locale = null;
        this.firstPageElementsCount = 5;
        this.scoreboardStartDate = null;
        this.lastUpdate = null;
        this.currentFreeText = "";
        this.bannerInterval = 0;
    }

    init() {
        let isComment = $('[data-' + this.isCommentData + ']').data(this.isCommentData);
        this.subSiteAcronym = $('[data-' + this.subSiteAcronymData + ']').data(this.subSiteAcronymData);
        this.liveEventPermalink = $('[data-' + this.liveEventPermalinkData + ']').data(this.liveEventPermalinkData);
        this.liveEventTitle = $('[data-' + this.liveEventTitleData + ']').data(this.liveEventTitleData);
        this.type = $('[data-' + this.liveEventTypeData + ']').data(this.liveEventTypeData);
        this.objectId = $('[data-' + this.objectIdData + ']').data(this.objectIdData);
        this.pageUrl = $('[data-' + this.pageUrlData + ']').data(this.pageUrlData);
        this.typology = $('[data-' + this.liveEventTypologyData + ']').data(this.liveEventTypologyData);
        this.intervalSeconds = parseInt($('[data-' + this.intervalSecondsData + ']').data(this.intervalSecondsData));
        this.comscorePageViewCandidateUrl = $('[data-' + this.comscoreUrlData + ']').data(this.comscoreUrlData);
        this.postTemplate = $('[data-' + this.postTemplateData + ']').data(this.postTemplateData);
        this.postSportTemplate = $('[data-' + this.postSportTemplateData + ']').data(this.postSportTemplateData);
        this.scoreBoardTemplate = $('[data-' + this.scoreBoardTemplateData + ']').data(this.scoreBoardTemplateData);
        this.webSocketAppKey = $('[data-' + this.webSocketAppKeyData + ']').data(this.webSocketAppKeyData);
        this.locale = $('[data-' + this.localeData + ']').data(this.localeData);
        this.firstPageElementsCount = $('[data-' + this.firstPageElementsCountData + ']').data(this.firstPageElementsCountData);
        this.freeText = [];
        this.freeText['first'] = $('[data-' + this.freeTextFirstData + ']').data(this.freeTextFirstData);
        this.freeText['rest'] = $('[data-' + this.freeTextRestData + ']').data(this.freeTextRestData);
        this.freeText['second'] = $('[data-' + this.freeTextSecondData + ']').data(this.freeTextSecondData);
        this.freeText['prorroga'] = $('[data-' + this.freeTextProrrogaData + ']').data(this.freeTextProrrogaData);
        this.freeText['penalties'] = $('[data-' + this.freeTextPenaltiesData + ']').data(this.freeTextPenaltiesData);
        this.freeText['final'] = $('[data-' + this.freeTextFinalData + ']').data(this.freeTextFinalData);
        this.lastUpdate = $('[data-' + this.lastUpdateData + ']').data(this.lastUpdateData);
        this.scoreboardStartDate = $('[data-' + this.scoreboardStartDateData + ']').data(this.scoreboardStartDateData);
        this.currentFreeText = $('[data-' + this.currentFreeTextData + ']').data(this.currentFreeTextData);
        this.bannerInterval = $('[data-' + this.bannerIntervalData + ']').data(this.bannerIntervalData);

        moment.locale(this.locale);

        if (isComment === 0) {
            this.initOrder();
            this.initAudioNotifications();
            this.initPaginator();
            if (this.type === 'open' && this.order === 'desc') {
                let _div = $('body').find('[data-' + this.jsonUrlData + ']');
                this.jsonUrl = $(_div).data(this.jsonUrlData);
                if (this.jsonUrl) {
                    this.initInterval();
                }
            }
        }

        if (this.typology === 'sports' && this.type === 'open') {
            this.initScoreBoard();
        }

        this.inicializeGallery();
        this.cleanData();
        this.webSocketValidation();
    }

    cleanData() {
        $('[data-' + this.liveEventPermalinkData + ']').removeAttr('data-' + this.liveEventPermalinkData);
        $('[data-' + this.liveEventTitleData + ']').removeAttr('data-' + this.liveEventTitleData);
        $('[data-' + this.subSiteAcronymData + ']').removeAttr('data-' + this.subSiteAcronymData);
        $('[data-' + this.pageUrlData + ']').removeAttr('data-' + this.pageUrlData);
        $('[data-' + this.jsonUrlData + ']').removeAttr('data-' + this.jsonUrlData);
        $('[data-' + this.objectIdData + ']').removeAttr('data-' + this.objectIdData);
        $('[data-' + this.notificationSoundData + ']').removeAttr('data-' + this.notificationSoundData);
        $('[data-' + this.liveEventTypeData + ']').removeAttr('data-' + this.liveEventTypeData);
        $('[data-' + this.intervalSecondsData + ']').removeAttr('data-' + this.intervalSecondsData);
        $(this.scoreBoardSelector).removeAttr('data-' + this.scoreBoardUpdateData);
        $('[data-' + this.liveEventTypologyData + ']').removeAttr('data-' + this.liveEventTypologyData);
        $('[data-' + this.isCommentData + ']').removeAttr('data-' + this.isCommentData);
        $('[data-' + this.comscoreUrlData + ']').removeAttr('data-' + this.comscoreUrlData);
        $('[data-' + this.freeTextFirstData + ']').removeAttr('data-' + this.freeTextFirstData);
        $('[data-' + this.freeTextRestData + ']').removeAttr('data-' + this.freeTextRestData);
        $('[data-' + this.freeTextSecondData + ']').removeAttr('data-' + this.freeTextSecondData);
        $('[data-' + this.freeTextProrrogaData + ']').removeAttr('data-' + this.freeTextProrrogaData);
        $('[data-' + this.freeTextFinalData + ']').removeAttr('data-' + this.freeTextFinalData);
        $('[data-' + this.scoreboardStartDateData + ']').removeAttr('data-' + this.scoreboardStartDateData);
        $('[data-' + this.bannerIntervalData + ']').removeAttr('data-' + this.bannerIntervalData);
    }

    initInterval() {
        let $this = this;

        if ($this.mustToUsePostWebSocket() === true) {
            $this.initWebSocket();
            if (this.type === 'open') {
                this.scoreBoardTimeInterval = setInterval(
                    function () {
                        $this.updateScoreBoardTime();
                    }, 60000
                );
            }
        } else {
            $this.interval = setInterval(
                function () {
                    $this.update();
                }, $this.intervalSeconds
            );
        }
    }

    initPaginator() {
        let $this = this;
        $('#live-event-paginator').on(
            'click', function () {
                $(this).addClass($this.LOADING_CLASS);
                $this.paginate();
            }
        );
    }

    initOrder() {
        $('[data-' + this.orderData + ']').on(
            'click', function () {
                $('.selector strong').html(jQuery(this).html());
                $('.selector-options')
                    .removeClass('open')
                    .slideToggle(200);
                window.location = window.location.pathname + '?order=' + encodeURIComponent($(this).data(this.orderData));
            }
        );

        let el = $('[data-' + this.orderSelectedData + ']');

        if (el) {
            this.order = el.data(this.orderSelectedData);
        }
    }

    initAudioNotifications() {
        let audioUrl = $('[data-' + this.notificationSoundData + ']').data(this.notificationSoundData);

        if (audioUrl) {
            this.notificationSound = new Audio(audioUrl);
        }
    }

    paginate() {
        let $this = this;
        let lastDate = $('[data-date]', '#live-events-container').last().data('date');
        $.get(
            this.pageUrl, {
                lastDate: lastDate,
                liveEventId: $this.objectId,
                order: $this.order,
                currentUrl: $this.currentUrl,
                typology: $this.typology
            }, function (data) {
                $this.renderComments(data.comments, true);
                if (!data.moreResults) {
                    $('#live-event-paginator').remove();
                }
            }
        ).always(
            function () {
                $('#live-event-paginator').removeClass($this.LOADING_CLASS);
            }
        );
    }

    update() {
        let $this = this;

        if (!$this.jsonUrl) {
            return false;
        }

        $this.doRequest(
            $this.jsonUrl, {liveEventId: $this.objectId, currentUrl: $this.currentUrl}, function (data) {
                if ($this.lastTimeStamp !== data.timestamp) {
                    let hasUpdate = $this.renderComments(data.comments);

                    $this.lastTimeStamp = data.timestamp;

                    if (hasUpdate) {
                        $this.notify();

                        $(window).trigger('cs:leftLiveEventBannerUpdatePosition', $this.typology);
                    }
                }
            }
        );
    }

    doRequest(url, params, callback) {
        params = typeof params === 'undefined' ? {} : params;
        callback = typeof callback === 'undefined' ? function () {
        } : callback;
        $.get(url, params, callback, 'json');
    }

    renderComments(data, pagination) {
        pagination = typeof pagination === 'undefined' ? false : pagination;

        let hasUpdate = false;

        if (data !== null && data.length > 0) {
            let length = data.length;

            for (let i = 0; i < length; i++) {
                let update = this._renderComment(data[i], pagination);
                if (update && !hasUpdate) {
                    hasUpdate = true;
                }
            }
        }

        this.inicializeGallery();
        document.dispatchEvent(new Event('DOMContentLoaded'));
        return hasUpdate;
    }

    _renderComment(data, pagination) {
        let element = $('[data-id="' + data.id + '"]');
        let container = this.commentContainer,
            date = moment(data.publishDate.date, 'YYYY-MM-DD HH:mm:ss'),
            hour = this.typology === this.TYPOLOGY_SPORTS ? data.timeText : date.format('HH:mm');

        if (hour === null && date !== null && this.typology === this.TYPOLOGY_SPORTS) {
            hour = date.format('HH:mm');
        } else if (hour === null) {
            hour = '';
        }

        let update = false;

        let elementHtml = $(data.html);

        if (data.title === null || data.title === '') {
            elementHtml.find('h2').remove();
        }

        if (hour === '') {
            elementHtml.find('.info').remove();
        }

        if (typeof data.format !== 'undefined' && data.format !== null && data.format !== '') {
            elementHtml
                .find('.live-event-post')
                .addClass(data.format);
        }

        if (element.length === 0 && !pagination) {
            container.prepend(elementHtml);

            setTimeout(
                function () {
                    elementHtml
                        .find('.live-event-post')
                        .addClass('highlight');
                }, 200
            );

            setTimeout(
                function () {
                    elementHtml
                        .find('.live-event-post')
                        .removeClass('highlight');
                }, 3000
            );

            update = true;
        } else if (pagination) {
            container.append(elementHtml);
            /*} else if(data.updatedAt !== null) {
                element.closest('.row').replaceWith(elementHtml);*/
        }

        $(window).trigger('cs:leftLiveEventBannerLoad');

        return update;
    }

    notify() {
        if (typeof moment !== 'undefined') {
            let lastDate = $('[data-id]', this.commentContainer).first().data('date');
            let text = $(this.updatedAtSelector).html();

            $(this.updatedAtSelector).html(
                text.split(' ')[0] + ' ' + moment(lastDate, "YYYY-MM-DD hh:mm:ss").fromNow()
            );
        }

        if (typeof window.gtag !== 'undefined') {
            //gtag('event', 'page_view', { 'send_to': 'GA_TRACKING_ID' });
        } else if (typeof ga !== 'undefined') {
            window.ga('send', {hitType: 'pageview', page: location.pathname});
        }

        if (typeof COMSCORE !== 'undefined' && this.comscorePageViewCandidateUrl !== null && typeof this.comscorePageViewCandidateUrl !== 'undefined' && this.comscorePageViewCandidateUrl !== '') {
            COMSCORE.beacon({c1: "2", c2: "21043127"});
            $.get(this.comscorePageViewCandidateUrl /*+ '&t=' +  Date.now()*/);
        }

        if (this.notificationSound) {
            this.notificationSound.play();
        }
    }

    initScoreBoard() {
        let scoreBoardElement = $(this.scoreBoardSelector),
            $this = this;

        if (scoreBoardElement.length > 0) {
            $this.scoreBoardUpdateUrl = scoreBoardElement.data($this.scoreBoardUpdateData);

            if (!$this.scoreBoardUpdateUrl) {
                return false;
            }

            if (isNaN($this.intervalSeconds)) {
                $this.intervalSeconds = parseInt($('[data-' + $this.intervalSecondsData + ']').data($this.intervalSecondsData));
            }

            if ($this.mustToUseScoreboardWebSocket() === false) {
                setInterval(
                    function () {
                        $this.updateScoreBoard();
                    }, $this.intervalSeconds
                );
            }
        }
    }

    updateScoreBoard() {
        let $this = this;
        $this.doRequest(
            $this.scoreBoardUpdateUrl, {liveEventId: $this.objectId}, function (data) {
                if (data.html) {
                    $($this.scoreBoardSelector).replaceWith(data.html);
                }
            }
        );
    }

    webSocketValidation() {
        if (
            this.postTemplate !== '' &&
            this.webSocketAppKey !== null &&
            typeof ComitiumLiveEventSocket === 'undefined'
        ) {
            console.info("ComitiumLiveEventSocket library must be load to use web sockets");
        }
    }

    initWebSocket() {
        let $this = this;

        ComitiumLiveEventSocket.init(this.webSocketAppKey, $this.objectId, {
            onConnect: function (data) {
                $this.webSocketOnConnect(data);
            },
            onCreate: function (data) {
                $this.webSocketOnCreate(data);
            },
            onUpdate: function (data) {
                $this.webSocketOnUpdate(data)
            },
            onDelete: function (data) {
                $this.webSocketOnDelete(data)
            },
            onScoreboardUpdate: function (data) {
                $this.webSocketScoreBoardOnUpdate(data)
            },
            computePresence: true,
            limit: $this.firstPageElementsCount,
            locale: $this.locale
        });
    }

    webSocketScoreBoardOnUpdate(data) {
        console.log("webSocketScoreBoardOnUpdate");
        console.log(data);

        let freeText = data.freeText ?? "";
        if (freeText) {
            freeText = this.freeText[freeText];
        }

        this.currentFreeText = data.freeText;

        let mapObj = {
            "__scoreBoard.homeTeam__": data.homeTeam,
            "__scoreBoard.homeValue__": data.homeValue,
            "__scoreBoard.awayTeam__": data.awayTeam,
            "__scoreBoard.awayValue__": data.awayValue,
            "__scoreBoard.freeText__": freeText
        };
        let regex = new RegExp(Object.keys(mapObj).join("|"), "gi");
        let html = $(this.scoreBoardTemplate.replace(regex, function (matched) {
            return mapObj[matched];
        }));

        $('[data-live-viewer-scoreboard]').html(html);

        if (data.startDate) {
            this.scoreboardStartDate = data.startDate;
        }

        this.notify();
        this.updateTime();
        this.updateScoreBoardTime(data);
    }

    updateScoreBoardTime(data) {
        let _freeText = "";
        let endTime = new Date();

        if (this.currentFreeText) {
            _freeText = this.freeText[this.currentFreeText];
        }

        if (typeof data != 'undefined') {
            this.scoreboardStartDate = data.startDate;
            if (data.endDate) {
                endTime = new Date(data.endDate);
            }
        }

        if (this.scoreboardStartDate) {
            let startTime = new Date(this.scoreboardStartDate);
            let timeDiff = endTime - startTime;

            timeDiff = timeDiff / 1000;
            timeDiff = timeDiff / 60;
            timeDiff = Math.floor(timeDiff);

            let dayDiff = timeDiff / 60;
            dayDiff = dayDiff / 24;
            dayDiff = Math.floor(dayDiff);

            if ((this.currentFreeText !== "final") && (this.currentFreeText !== "rest") && (this.type === "open")) {
                if ((timeDiff > 0) && (timeDiff < 240) && (dayDiff < 1)) {
                    timeDiff = timeDiff.toString() + "'";
                    _freeText = _freeText + " ( " + timeDiff + " ) ";
                }
            }
        }

        $('[data-scoreboard-text]').html(_freeText);
    }

    updateTime() {
        let endTime = new Date();

        let year = endTime.getFullYear();
        let month = (1 + endTime.getMonth()).toString().padStart(2, '0');
        let day = endTime.getDate().toString().padStart(2, '0');

        let hour = endTime.getHours().toString().padStart(2, '0');
        let minute = endTime.getMinutes().toString().padStart(2, '0');

        let updateTime = day + "/" + month + "/" + year + " " + hour + ":" + minute
        let updateString = this.lastUpdate.replace("%date%", updateTime);

        let element = $('[data-id="time-diff"]');
        if (element.length > 0) {
            element.html(updateString);
        }
    }

    isSport() {
        return this.typology === 'sports';
    }

    mustToUsePostWebSocket() {
        return (
            this.postTemplate !== '' &&
            this.webSocketAppKey !== null &&
            typeof ComitiumLiveEventSocket !== 'undefined'
        );
    }

    mustToUseScoreboardWebSocket() {
        return (
            this.scoreBoardTemplate !== '' &&
            this.webSocketAppKey !== null &&
            typeof ComitiumLiveEventSocket !== 'undefined'
        );
    }

    renderPost(post) {
        let _postList = $('body').find('[data-live-viewer-posts-list]');
        $(_postList).prepend(post.html);
    }

    renderWebSocketPost(template, data) {
        let text = encodeURIComponent($("<div>").html((data.title ? data.title + ' // ' : '') + (data.description ? data.description : '') + " #DebatRiudoms ").text());
        let url = encodeURIComponent(this.liveEventPermalink + "?idComment=" + data.id);

        let facebookShareUrl = "https://www.facebook.com/sharer/sharer.php?u=" + url;
        let facebookIconUrl = "/uploads/static/" + this.subSiteAcronym + "/icons/icon-generic.svg#icon-facebook";

        let twitterShareUrl = "https://twitter.com/intent/tweet?text=" + text + " " + url;
        let twitterIconUrl = "/uploads/static/" + this.subSiteAcronym + "/icons/icon-generic.svg#icon-twitter";

        let linkedinShareUrl = "https://www.linkedin.com/shareArticle?mini=true&url=" + url + "&title=" + text;
        let linkedinIconUrl = "/uploads/static/" + this.subSiteAcronym + "/icons/icon-generic.svg#icon-linkedin";

        let whatsappWebShareUrl = "https://web.whatsapp.com/send?text=" + text + url;
        let whatsappWebIconUrl = "/uploads/static/" + this.subSiteAcronym + "/icons/icon-generic.svg#icon-whatsapp";

        let whatsappMobileShareUrl = "https://api.whatsapp.com/send?text=" + text + url;
        let whatsappMobileIconUrl = "/uploads/static/" + this.subSiteAcronym + "/icons/icon-generic.svg#icon-whatsapp";

        let telegramWebShareUrl = "https://web.telegram.org/#/im?tgaddr=tg://msg_url?url=" + url + "&text=" + text;
        let telegramWebIconUrl = "/uploads/static/" + this.subSiteAcronym + "/icons/icon-generic.svg#icon-telegram";

        let telegramMobileShareUrl = "https://t.me/share/?url=" + url + "&text=" + text;
        let telegramMobileIconUrl = "/uploads/static/" + this.subSiteAcronym + "/icons/icon-generic.svg#icon-telegram";

        let mailShareUrl = "mailto:?subject=" + this.liveEventTitle + "&body=" + text + " " + url;
        let mailIconUrl = "/uploads/static/" + this.subSiteAcronym + "/icons/icon-generic.svg#icon-mail";

        let mapObj = {
            "__post.id__": data.id,
            "__post.title__": data.title ? data.title : '',
            "__post.description__": data.description ? data.description : '',
            "__post.format__": String(data.format),
            "__post.publishDate__": moment(data.publishDate).format("Y-MM-DD HH:mm:ss"),
            "__post.publishDate_time__": moment(data.publishDate).format("HH:mm") + "h",
            "__post.publishDate_date__": moment(data.publishDate).format("DD/MM/Y"),
            "__post.facebook_share_url__": facebookShareUrl,
            "__post.facebook_icon_url__": facebookIconUrl,
            "__post.twitter_share_url__": twitterShareUrl,
            "__post.twitter_icon_url__": twitterIconUrl,
            "__post.linkedin_share_url__": linkedinShareUrl,
            "__post.linkedin_icon_url__": linkedinIconUrl,
            "__post.whatsappweb_share_url__": whatsappWebShareUrl,
            "__post.whatsappweb_icon_url__": whatsappWebIconUrl,
            "__post.whatsappmobile_share_url__": whatsappMobileShareUrl,
            "__post.whatsappmobile_icon_url__": whatsappMobileIconUrl,
            "__post.telegramweb_share_url__": telegramWebShareUrl,
            "__post.telegramweb_icon_url__": telegramWebIconUrl,
            "__post.telegrammobile_share_url__": telegramMobileShareUrl,
            "__post.telegrammobile_icon_url__": telegramMobileIconUrl,
            "__post.mail_share_url__": mailShareUrl,
            "__post.mail_icon_url__": mailIconUrl,
        };

        let regex = new RegExp(Object.keys(mapObj).join("|"), "gi");

        return template.replace(regex, function (matched) {
            return mapObj[matched];
        });
    }

    renderWebSocketSportPost(template, data) {
        let facebookShareUrl = "https://www.facebook.com/sharer/sharer.php?u=" + this.liveEventPermalink + "&idComment=" + data.id;
        let facebookIconUrl = "/uploads/static/" + this.subSiteAcronym + "/dist/icons/icon-generic.svg#icon-facebook";

        let twitterShareUrl = "https://twitter.com/intent/tweet?text=" + this.liveEventTitle + "&idComment=" + data.id;
        let twitterIconUrl = "/uploads/static/" + this.subSiteAcronym + "/dist/icons/icon-generic.svg#icon-twitter";

        let linkedinShareUrl = "https://www.linkedin.com/shareArticle?mini=true&url=" + this.liveEventPermalink + "&idComment=" + data.id + "&title=" + this.liveEventTitle;
        let linkedinIconUrl = "/uploads/static/" + this.subSiteAcronym + "/dist/icons/icon-generic.svg#icon-linkedin";

        let whatsappWebShareUrl = "https://web.whatsapp.com/send?text=" + this.liveEventTitle + this.liveEventPermalink + "&idComment=" + data.id;
        let whatsappWebIconUrl = "/uploads/static/" + this.subSiteAcronym + "/dist/icons/icon-generic.svg#icon-whatsapp";

        let whatsappMobileShareUrl = "https://api.whatsapp.com/send?text=" + this.liveEventTitle + this.liveEventPermalink + "&idComment=" + data.id;
        let whatsappMobileIconUrl = "/uploads/static/" + this.subSiteAcronym + "/dist/icons/icon-generic.svg#icon-whatsapp";

        let telegramWebShareUrl = "https://web.telegram.org/#/im?tgaddr=tg://msg_url?url=" + this.liveEventPermalink + "&idComment=" + data.id + "&text=" + this.liveEventTitle;
        let telegramWebIconUrl = "/uploads/static/" + this.subSiteAcronym + "/dist/icons/icon-generic.svg#icon-telegram";

        let telegramMobileShareUrl = "https://t.me/share/?url=" + this.liveEventPermalink + "&idComment=" + data.id + "&text=" + this.liveEventTitle
        let telegramMobileIconUrl = "/uploads/static/" + this.subSiteAcronym + "/dist/icons/icon-generic.svg#icon-telegram";

        let mailShareUrl = "mailto:?subject=" + this.liveEventTitle + "&body=" + this.liveEventPermalink + "&idComment=" + data.id
        let mailIconUrl = "/uploads/static/" + this.subSiteAcronym + "/dist/icons/icon-generic.svg#icon-mail";

        let mapObj = {
            "__post.id__": data.id,
            "__post.title__": data.title ? data.title : "",
            "__post.publishDate__": moment(data.publishDate).format("Y-MM-DD HH:mm:ss"),
            "__post.publishDate_time__": moment(data.publishDate).format("HH:mm") + "h",
            "__post.publishDate_date__": moment(data.publishDate).format("DD/MM/Y"),
            "__post.description__": data.description ? data.description : "",
            "__post.format__": data.format ? String(data.format) : '',
            "__post.timeText__": data.timeText ? data.timeText + "'" : '',
            "__post.facebook_share_url__": facebookShareUrl,
            "__post.facebook_icon_url__": facebookIconUrl,
            "__post.twitter_share_url__": twitterShareUrl,
            "__post.twitter_icon_url__": twitterIconUrl,
            "__post.linkedin_share_url__": linkedinShareUrl,
            "__post.linkedin_icon_url__": linkedinIconUrl,
            "__post.whatsappweb_share_url__": whatsappWebShareUrl,
            "__post.whatsappweb_icon_url__": whatsappWebIconUrl,
            "__post.whatsappmobile_share_url__": whatsappMobileShareUrl,
            "__post.whatsappmobile_icon_url__": whatsappMobileIconUrl,
            "__post.telegramweb_share_url__": telegramWebShareUrl,
            "__post.telegramweb_icon_url__": telegramWebIconUrl,
            "__post.telegrammobile_share_url__": telegramMobileShareUrl,
            "__post.telegrammobile_icon_url__": telegramMobileIconUrl,
            "__post.mail_share_url__": mailShareUrl,
            "__post.mail_icon_url__": mailIconUrl,
        };

        let regex = new RegExp(Object.keys(mapObj).join("|"), "gi");

        return template.replace(regex, function (matched) {
            return mapObj[matched];
        });
    }

    webSocketOnConnect(data) {
        console.log("webSocketOnConnect");
        console.log(data);

        if (data.length === 0)
            return;

        let _this = this, html = '';

        if (this.isSport()) {
            data.reverse();
            data.forEach(function (entry) {
                let _postList = $('body').find('[data-live-viewer-posts-list]');
                let _postKey = '[data-ws-post="' + entry.id + '"]';
                let _renderedPost = $(_postList).find(_postKey);
                if (_renderedPost.length === 0) {
                    html = _this.renderWebSocketSportPost(_this.postSportTemplate, entry);
                    $(_postList).prepend(html);
                } else {
                    html = _this.renderWebSocketSportPost(_this.postSportTemplate, entry);
                    $(_renderedPost).replaceWith(html);
                }
            });
        } else {
            data.reverse();
            data.forEach(function (entry) {
                let _postList = $('body').find('[data-live-viewer-posts-list]');
                let _postKey = '[data-ws-post="' + entry.id + '"]';
                let _renderedPost = $(_postList).find(_postKey);
                if (_renderedPost.length === 0) {
                    html = _this.renderWebSocketPost(_this.postTemplate, entry);
                    $(_postList).prepend(html);
                } else {
                    html = _this.renderWebSocketPost(_this.postTemplate, entry);
                    $(_renderedPost).replaceWith(html);
                }
            });
        }

        if (this.typology == "sports") {
            this.updateScoreBoardTime();
        }

        let _event = new CustomEvent('cs:updateBannersPosition', {detail: {bannerInterval: this.bannerInterval}});
        document.dispatchEvent(_event);
    }

    webSocketOnCreate(data) {
        console.log("webSocketOnCreate");
        console.log(data);

        if (data.locale !== this.locale) {
            return;
        }

        let post = "";

        if (this.isSport()) {
            post = Object.assign(data, {html: this.renderWebSocketSportPost(this.postSportTemplate, data)});
        } else {
            post = Object.assign(data, {html: this.renderWebSocketPost(this.postTemplate, data)});
        }

        this.renderPost(post);
        this.notify();

        let _event = new CustomEvent('cs:updateBannersPosition', {detail: {bannerInterval: this.bannerInterval}});
        document.dispatchEvent(_event);

        document.dispatchEvent(new Event('DOMContentLoaded'))
        this.updateTime();
        if (this.isSport()) {
            this.updateScoreBoardTime();
        }
    }

    webSocketOnUpdate(data) {
        console.log("webSocketOnUpdate");
        console.log(data);

        if (data.locale !== this.locale) {
            return;
        }

        let element = $('[data-ws-post="' + data.id + '"]');

        if (element) {
            if (this.isSport()) {
                element.replaceWith(this.renderWebSocketSportPost(this.postSportTemplate, data));
            } else {
                element.replaceWith(this.renderWebSocketPost(this.postTemplate, data));
            }
        }

        this.notify();

        this.updateTime();
        if (this.isSport()) {
            this.updateScoreBoardTime();
        }
    }

    webSocketOnDelete(data) {
        console.log("webSocketOnDelete");
        console.log(data);

        if (data.locale !== this.locale) {
            return;
        }

        let element = $('[data-ws-post="' + data.id + '"]');

        if (element) {
            element.remove();
        }

        this.notify();

        let _event = new CustomEvent('cs:updateBannersPosition', {detail: {bannerInterval: this.bannerInterval}});
        document.dispatchEvent(_event);

        this.updateTime();
        if (this.isSport()) {
            this.updateScoreBoardTime();
        }
    }

    cutText(text, length) {
        if (text.length < length) {
            return text;
        }

        length = length - 3;
        let trimmedString = text.substr(0, length);

        return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + '...';
    }

    inicializeGallery() {
        $('[data-swiper-container]').each(function () {
            new Swiper($(this), {
                pagination: $(this).find('.swiper-pagination'),
                nextButton: $(this).find('.swiper-button-next'),
                prevButton: $(this).find('.swiper-button-prev'),
                slidesPerView: 1,
                paginationClickable: true,
                spaceBetween: 30
            });
            $(this).find('[data-popup-gallery]').magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Loading image...',
                mainClass: 'mfp-img-mobile',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1],
                    tCounter: '%curr% / %total%'
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function (item) {
                        return item.el.attr('title');
                    }
                }
            });
        });
    }
}

export default LiveEventsManager